import { render, staticRenderFns } from "./NavAlert.vue?vue&type=template&id=789f8abf&scoped=true&"
import script from "./NavAlert.vue?vue&type=script&lang=js&"
export * from "./NavAlert.vue?vue&type=script&lang=js&"
import style0 from "./NavAlert.vue?vue&type=style&index=0&id=789f8abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789f8abf",
  null
  
)

export default component.exports